import styles from '../StepLayout.module.css';
import { StepLayout } from '../StepLayout';
import { ru } from '@/i18n/ru';

export function Step5Flow() {
  return (
    <StepLayout title={ru.onboarding.step5.title}>
      <ol className={styles.list}>
        {ru.onboarding.step5.steps.map((s) => (
          <li key={s}>{s}</li>
        ))}
      </ol>
    </StepLayout>
  );
}
